import AlertModal from '@/components/ux/AlertModal/AlertModal';
import { useCampaignBuilderStore, useCoMarketingSponsorEditStore } from '@/stores';
import React from 'react';
import { create } from 'zustand';
import { CampaignEditingMethod } from '../campaign.builder.utils';

// zustand store to control open/close state
export const useCoMarketingChangesPromptStore = create<CoMarketingChangesPromptStore>((set) => ({
	open: undefined,
	setOpen: (open) => set({ open }),
}));

interface CoMarketingChangesPromptStore {
	// If this is open for the 'sponsor' then they have changes from the sponsor to apply
	// If this is open for the 'installer' then they have changes from the installer to apply
	open: 'sponsor' | 'installer' | undefined;
	setOpen: (open: 'sponsor' | 'installer' | undefined) => void;
}

export default function CoMarketingChangesPrompt() {
	const { applyEditRequestCampaign } = useCampaignBuilderStore();
	const { open, setOpen } = useCoMarketingChangesPromptStore();

	const title = React.useMemo(() => {
		if (open === 'sponsor') {
			return 'Edits requested by Sponsor';
		}
		return 'Edits requested by Installer';
	}, [open]);

	const description = React.useMemo(() => {
		if (open === 'sponsor') {
			return 'The template sponsor has requested edits to this co-marketing template. Please review the changes and approve or request further edits.';
		}
		return 'Installer has requested edits to this co-marketing template. Please review the changes and approve or request further edits.';
	}, [open]);

	const onConfirm = React.useCallback(() => {
		const editingMethod = open === 'sponsor' ? CampaignEditingMethod.REVIEW_SPONSOR_CHANGES : CampaignEditingMethod.REVIEW_INSTALLER_CHANGES;
		applyEditRequestCampaign(editingMethod);
	}, [open]);

	return (
		<>
			<AlertModal
				open={open !== undefined}
				onConfirm={onConfirm}
				onClose={() => setOpen(undefined)}
				title={title}
				description={description}
				cancelButtonLabel="Ignore"
				confirmButtonLabel="View Edits"
			/>
		</>
	);
}
